// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"28":"21d94907","74":"f05f6478","211":"52312683","277":"034a8be9","453":"61afda7a","629":"7883ceda","912":"2e6851f5"}[chunkId] + ".chunk.js";
};